// eslint-disable-next-line import/prefer-default-export
export const CLASS_HREF = '/class/[slug]/[uid]';

export const thumbnailMapping = {
  a: 'https://static.uacdn.net/web-cms/playlist_thumbnail_a_75a4cfbe49.png',
  b: 'https://static.uacdn.net/web-cms/playlist_thumbnail_b_05e57264a4.png',
  c: 'https://static.uacdn.net/web-cms/playlist_thumbnail_c_60c024069a.png',
  d: 'https://static.uacdn.net/web-cms/playlist_thumbnail_d_c1094414c3.png',
  e: 'https://static.uacdn.net/web-cms/playlist_thumbnail_e_6c3408da07.png',
  f: 'https://static.uacdn.net/web-cms/playlist_thumbnail_f_20185317a6.png',
  g: 'https://static.uacdn.net/web-cms/playlist_thumbnail_g_19bca17fc6.png',
  h: 'https://static.uacdn.net/web-cms/playlist_thumbnail_h_809dd7605b.png',
  i: 'https://static.uacdn.net/web-cms/playlist_thumbnail_i_2eb163b667.png',
  j: 'https://static.uacdn.net/web-cms/playlist_thumbnail_j_deae67554c.png',
  k: 'https://static.uacdn.net/web-cms/playlist_thumbnail_k_f5e0165eff.png',
  l: 'https://static.uacdn.net/web-cms/playlist_thumbnail_l_d24fc4cb82.png',
  m: 'https://static.uacdn.net/web-cms/playlist_thumbnail_m_1be5f3ed04.png',
  n: 'https://static.uacdn.net/web-cms/playlist_thumbnail_n_c60662b6ac.png',
  o: 'https://static.uacdn.net/web-cms/playlist_thumbnail_o_ff19947540.png',
  p: 'https://static.uacdn.net/web-cms/playlist_thumbnail_p_1622263294.png',
  q: 'https://static.uacdn.net/web-cms/playlist_thumbnail_q_649936d684.png',
  r: 'https://static.uacdn.net/web-cms/playlist_thumbnail_r_da2c28b700.png',
  s: 'https://static.uacdn.net/web-cms/playlist_thumbnail_s_f2fb5c1e7a.png',
  t: 'https://static.uacdn.net/web-cms/playlist_thumbnail_t_490f296423.pngg',
  u: 'https://static.uacdn.net/web-cms/playlist_thumbnail_u_fc0aeeae16.png',
  v: 'https://static.uacdn.net/web-cms/playlist_thumbnail_v_12c6b3d8e1.png',
  w: 'https://static.uacdn.net/web-cms/playlist_thumbnail_w_326a590583.png',
  x: 'https://static.uacdn.net/web-cms/playlist_thumbnail_x_e620266528.png',
  y: 'https://static.uacdn.net/web-cms/playlist_thumbnail_y_e307a0f292.png',
  z: 'https://static.uacdn.net/web-cms/playlist_thumbnail_z_212bc69fc4.png'
};
